import React from "react";

export function Button1() {
  return <button>I'm a button 1</button>;
}

export function Button2() {
  return <button>I'm a button 2</button>;
}

export default {
  title: "Buttons",
};
